import { UserClass, Privileges } from ".";
import { HashSet, List, ValueEncoder } from "DiscoveryEngine.TS/Utils";
import { ShareDto } from "..";
import { ObjSerUtils } from "DiscoveryEngine.TS/Serialization";


export class UserPermissions {

	private static readonly Default_EffectiveUserClass = UserClass.Observer;

	public UserGuid: string;
	public Timestamp: Date;
	public EffectiveUserClass: UserClass;
	public EffectivePrivileges: Privileges;
	public EffectiveGroups: HashSet<string>;
	public EffectiveSourceShares: List<ShareDto>;
	public EffectiveTargetShares: List<ShareDto>;

	constructor() {
		this.Clear();
	}

	public Clear(): void {
		this.UserGuid = "";
		this.Timestamp = undefined;
		this.EffectiveUserClass = UserPermissions.Default_EffectiveUserClass;
		this.EffectivePrivileges = new Privileges();
		this.EffectiveGroups = new HashSet<string>();
		this.EffectiveSourceShares = new List<ShareDto>();
		this.EffectiveTargetShares = new List<ShareDto>();
	}

	public get HasUserGuid(): boolean {
		return !!this.UserGuid;
	}

	public get HasTimestamp(): boolean {
		return (this.Timestamp !== undefined);
	}

	public get HasEffectivePrivileges(): boolean {
		return this.EffectivePrivileges.HasEntries;
	}

	public get HasEffectiveGroups(): boolean {
		return (!!this.EffectiveGroups && this.EffectiveGroups.Count > 0);
	}

	public get HasEffectiveSourceShares(): boolean {
		return (!!this.EffectiveSourceShares && this.EffectiveSourceShares.Count > 0);
	}

	public get HasEffectiveTargetShares(): boolean {
		return (!!this.EffectiveTargetShares && this.EffectiveTargetShares.Count > 0);
	}

	public Write(obj: any, context: any): void {

		obj.user_permissions = {};
		obj = obj.user_permissions;

		if (this.HasUserGuid) {
			obj.user_guid = this.UserGuid;
		}
		if (this.HasTimestamp) {
			obj.timestamp = ValueEncoder.EncodeDateTime(this.Timestamp);
		}

		obj.effective_user_class = UserClass[this.EffectiveUserClass];

		if (this.HasEffectivePrivileges) {
			context[Privileges.ObjSer_ObjectName] = "effective_privileges";
			this.EffectivePrivileges.Write(obj, context);
		}
		if (this.HasEffectiveGroups) {
			obj.effective_groups = [];
			ObjSerUtils.WriteStringEntryCollection(obj.effective_groups, this.EffectiveGroups, context);
		}
		if (this.HasEffectiveSourceShares) {
			obj.effective_source_shares = [];
			ObjSerUtils.WriteObjSerCollection(obj.effective_source_shares, this.EffectiveSourceShares, context);
		}
		if (this.HasEffectiveTargetShares) {
			obj.effective_target_shares = [];
			ObjSerUtils.WriteObjSerCollection(obj.effective_target_shares, this.EffectiveTargetShares, context);
		}
	}

	public Read(obj: any, context: any): void {

		if (!obj.user_permissions)
			throw new Error();
		obj = obj.user_permissions;

		if (obj.user_guid !== undefined) {
			this.UserGuid = obj.user_guid;
		}
		if (obj.timestamp !== undefined) {
			this.Timestamp = ValueEncoder.DecodeDateTime(obj.timestamp);
		}
		if (obj.effective_user_class !== undefined) {
			this.EffectiveUserClass = UserClass[<string>obj.effective_user_class];
		}
		if (obj.effective_privileges !== undefined) {
			context[Privileges.ObjSer_ObjectName] = "effective_privileges";
			this.EffectivePrivileges = new Privileges();
			this.EffectivePrivileges.Read(obj, context);
		}
		if (obj.effective_groups !== undefined) {
			this.EffectiveGroups = new HashSet<string>();
			ObjSerUtils.ReadStringEntryCollection(obj.effective_groups, this.EffectiveGroups, context);
		}
		if (obj.effective_source_shares !== undefined) {
			this.EffectiveSourceShares = new List<ShareDto>();
			ObjSerUtils.ReadObjSerCollection(obj.effective_source_shares, this.EffectiveSourceShares,
				(value: any) => new ShareDto(), context);
		}
		if (obj.effective_target_shares !== undefined) {
			this.EffectiveTargetShares = new List<ShareDto>();
			ObjSerUtils.ReadObjSerCollection(obj.effective_target_shares, this.EffectiveTargetShares,
				(value: any) => new ShareDto(), context);
		}
	}

}
